
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 116 91"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","transform":"translate(0 .5)"}},[_c('rect',{attrs:{"width":"115","height":"89","x":".5","y":".5","fill":"#FFF","stroke":"#E0E4EC","rx":"4"}}),_c('path',{attrs:{"fill":"#C1C8D6","fill-rule":"nonzero","d":"M32.192 34.461l17.035 7.096 19.418 5.425.214.012L86.755 44.1l13.78-12.227-.663-.748L86.308 43.16l-17.5 2.829-19.254-5.375-17.2-7.168-.22-.093-16.374 8.94.48.877z"}}),_c('path',{attrs:{"stroke":"#05B5E4","stroke-width":"3","d":"M16 64.5l16.845-20.393h15.92L68.778 38.5l17.635 22.169 13.79-9.169"}}),_c('path',{attrs:{"fill":"#0C3454","d":"M19 76.5h84v4H15v-63h4v59z"}})])])
          )
        }
      }
    